import React from "react"

import Layout from "../components/allstar/layout"
import SectionHero from "../components/allstar/resource/faq/section-hero"
import SectionBody from "../components/allstar/resource/faq/section-body"
import { graphql } from "gatsby"

const ResourceFAQPage = props => {
  return (
    <Layout
      location={props.location}
      title={"Frequently Asked Questions (FAQ)"}
      isResourceSite
    >
      <SectionHero data={props.data} />
      <SectionBody data={props.data} />
    </Layout>
  )
}

export default ResourceFAQPage

export const query = graphql`
  query resourcesFaqQuery {
    allBadges: allFile(
      filter: { relativeDirectory: { eq: "allstar/badges" } }
    ) {
      edges {
        node {
          name
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
  }
`
